export default {
  MODALITY_CONVENTIONAL: 'conventional',
  NATIONAL_CURRENCY: 'BRL',
  NO_ONE_MODALITY_FOUND: 'Nenhuma modalidade encontrada',
  NO_PRICE_MODALITY_FOUND: 'Nenhum preço por modalidade encontrada'
};